<template>
  <div>
    <b-tabs
      v-model="tabIndex"
    >
      <b-tab title="Details">
        <BusinessDetails business-type="ride-hailing" />
      </b-tab>
      <b-tab title="Branches">
        <BusinessBranchesList
          :business-id="businessId"
        />
      </b-tab>
      <b-tab title="Fixed Locations">
        <FixedLocationsForm />
      </b-tab>
      <b-tab title="Wallet">
        <BusinessWallet />
      </b-tab>
      <b-tab title="Linked Drivers Trips History">
        <LinkedDriversTrips />
      </b-tab>

      <b-tab title="Linked Admins">
        <LinkedAdmins />
      </b-tab>

    </b-tabs>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BTabs, BTab,
} from 'bootstrap-vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import businessStore from '../store'
import BusinessBranchesList from '../components/BusinessBranchesList.vue'
import BusinessWallet from '../components/wallet/BusinessWallet.vue'
import BusinessDetails from '../components/business-details.vue'
import LinkedDriversTrips from '../components/fleet-management/LinkedDriversTrips.vue'
import FixedLocationsForm from '../components/ride-hailing/FixedLocationsForm.vue'
import LinkedAdmins from '../components/LinkedAdmins.vue'

export default {
  components: {
    BTabs,
    BTab,
    BusinessBranchesList,
    BusinessWallet,
    BusinessDetails,
    LinkedDriversTrips,
    FixedLocationsForm,
    LinkedAdmins,
  },
  setup(_, ctx) {
    useRegisterStoreModule('business', businessStore)

    const tabIndex = ref(0)
    const businessId = ctx.root.$route.params.id
    const businessExternalId = ctx.root.$route.query.externalId

    return {
      tabIndex,
      businessExternalId,
      businessId,
    }
  },
}
</script>
